<!-- SpaceConfig -->
<ng-container *ngFor="let row of leftWindowPositions(); let i = index; trackBy: trackByIndex">
    <ng-container *ngFor="let position of row; let j = index">
        <svg:g [attr.transform]="'translate(' + position.x + ', ' + position.y + ')'">
            <svg:path
                class="window-left"
                [style.animationDelay]="i * j * 0.01 + 's'"
                d="M24.8452 64.398L1.47827 53.1152L0.984375 0.458496L24.3535 11.7682L24.8452 64.398Z"
                [attr.fill]="position.isLit ? 'var(--window-lit-bg-1)' : 'var(--window-dark-bg-1)'" />
        </svg:g>
    </ng-container>
</ng-container>

<ng-container *ngFor="let row of rightWindowPositions(); let i = index; trackBy: trackByIndex">
    <ng-container *ngFor="let position of row; let j = index">
        <svg:g [attr.transform]="'translate(' + position.x + ', ' + position.y + ')'">
            <svg:path
                class="window-right"
                [style.animationDelay]="i * j * 0.01 + 's'"
                d="M0.904408 70.2893L23.6193 58.2896L23.0821 0.533691L0.367188 12.4864L0.904408 70.2893Z"
                [attr.fill]="position.isLit ? 'var(--window-lit-bg-2)' : 'var(--window-dark-bg-2)'" />
        </svg:g>
    </ng-container>
</ng-container>
